
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificate/e/[enrollmentId]",
      function () {
        return require("private-next-pages/certificate/e/[enrollmentId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certificate/e/[enrollmentId]"])
      });
    }
  